import React from "react";

export default function ValidationPendingNotice({ title, body, compact = false }) {
  return (
    <div
      className={`rounded-[18px] border border-amber-200/35 bg-amber-300/12 text-amber-50 shadow-[0_12px_28px_rgba(0,0,0,0.16)] ${
        compact ? "px-3.5 py-3" : "px-4 py-3.5"
      }`}
      role="status"
    >
      <div className="flex items-start gap-3">
        <span
          className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-200 text-[13px] font-black leading-none text-[#17213B]"
          aria-hidden="true"
        >
          !
        </span>
        <div className="min-w-0">
          <p className={`${compact ? "text-[13px] leading-[18px]" : "text-[15px] leading-5"} font-extrabold`}>
            {title}
          </p>
          <p className={`mt-1 font-medium text-amber-50/80 ${compact ? "text-[11px] leading-4" : "text-[13px] leading-[18px]"}`}>
            {body}
          </p>
        </div>
      </div>
    </div>
  );
}
